<template>
  <section
    v-if="liveSportsValid.length > 0"
    class="m-live-container tw-rounded-[20px]"
    v-block-loading:initFetch="loading"
  >
    <SectionNavs
      v-if="!productDownOfLive"
      :sport-id="currentSportId"
      track-type="Live"
      :sport-list="liveSportsValid"
      @change="onChangeSport"
    >
      <template slot="title">
        <!-- for seo -->
        <span style="display: none">Live</span>
        <img
          :src="liveTitleIcon"
          alt="Live"
          loading="lazy"
        />
      </template>
    </SectionNavs>
    <template v-if="loading === false">
      <template v-if="!productDownOfLive">
        <MarketNavs
          v-if="defaultMarkets.length > 0"
          v-model="currentMarketId"
          class="market-navs"
          :market-list="defaultMarkets"
          :fixed-value="false"
          @change="onChangeMarket"
        />
        <LiveBetting
          :sport-id="currentSportId"
          :sport-name="currentSportName"
          :market-id="currentMarketId"
        />
      </template>

      <!-- product down -->
      <LiveProductDown
        v-else
        :virtuals-url="virtualsUrl"
      />
    </template>
  </section>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useRealSportsStore } from '@ms/stores/realsports.js'
import useCurrentSport from '@ms/stores/sports/useCurrentSport.js'
import { useSportsLiveStore } from '@ms/stores/sportsLive'
import { prefixLink } from '@ms/config/app'
import SectionNavs from '../modules/SectionNavs'
import MarketNavs from 'wap/match/MarketNavs'
import LiveBetting from '../modules/LiveBetting'
import LiveProductDown from '../components/LiveProductDown.vue'
import useDefaultMarket from 'composables/market/useDefaultMarket.js'
import useHomeStore from 'wap/stores/home'
import { useThemeImage } from 'composables/useThemeImage.js'

export default {
  name: 'LiveContainer',
  components: {
    SectionNavs,
    MarketNavs,
    LiveBetting,
    LiveProductDown
  },
  setup() {
    const { productDownOfLive } = storeToRefs(useRealSportsStore())
    const { currentSportId, currentSportName, updateCurrentSportId } = useCurrentSport()

    const { liveSportsValid } = storeToRefs(useSportsLiveStore())

    const { defaultMarkets, getMarketInfo } = useDefaultMarket()

    const liveTitleIcon = useThemeImage({
      light: {
        default: require('../images/live-light@2x.png')
      },
      dark: {
        default: require('../images/live-dark@2x.png')
      }
    })

    return {
      virtualsUrl: prefixLink('/virtual'),
      liveSportsValid,
      currentSportId,
      currentSportName,
      updateCurrentSportId,

      defaultMarkets,
      getMarketInfo,
      productDownOfLive,
      liveTitleIcon
    }
  },
  data() {
    return {
      currentMarketId: '',
      loading: true
    }
  },
  created() {
    const { lmId } = this.$route.query
    if (lmId) {
      this.currentMarketId = lmId
    }
    this.initFetch()
  },
  activated() {
    const { currentSportId } = this
    if (currentSportId) {
      useHomeStore().getLiveMatches({ sportId: currentSportId }).catch(console.error)
    }
  },
  methods: {
    // 这个方法纯碎是为了一起获取 sports, markets, events, 方便初次加载 loading
    async initFetch() {
      this.loading = true
      try {
        await this.parseQueryId()
        this.setSportId()
        if (this.currentSportId) {
          await Promise.all([useHomeStore().getLiveMatches({ sportId: this.currentSportId }), this.fetchMarketInfo()])
        }
        this.loading = false
      } catch (error) {
        if (error === 'canceled' || error.canceled) {
          return
        }
        this.loading = -1
      }
    },
    setSportId() {
      // 检查 current sportId 是否有效
      const { liveSportsValid, currentSportId } = this
      if (liveSportsValid.length) {
        const isValid = liveSportsValid.find((x) => x.sportId === currentSportId)
        if (!isValid) {
          this.updateCurrentSportId(liveSportsValid[0].sportId)
        }
      }
    },
    // 获取运动列表
    async parseQueryId() {
      const { sportId } = this.$route.query
      if (sportId && !this.currentSportId) {
        this.updateCurrentSportId(sportId)
      }
    },
    // 获取 market 导航列表
    async fetchMarketInfo() {
      await this.getMarketInfo({ sportId: this.currentSportId })
      // 检查 currentMarketId 是否有效
      const { currentMarketId, defaultMarkets } = this
      if (currentMarketId) {
        const isValid = defaultMarkets.findIndex((x) => x.id === currentMarketId) !== -1
        if (!isValid) {
          // 若无效，则重置为默认第一个
          this.currentMarketId = defaultMarkets[0].id
        }
      } else {
        this.currentMarketId = defaultMarkets[0].id
      }
    },
    async onChangeSport(sportId) {
      this.updateCurrentSportId(sportId)
      this.initFetch()
      const query = { ...this.$route.query }
      query.sportId = sportId
      delete query.lmId
      this.$router.replace({ query })
    },
    onChangeMarket(marketId) {
      const query = { ...this.$route.query }
      query.lmId = marketId
      this.$router.replace({ query })
    }
  }
}
</script>

<style lang="scss">
.m-live-container {
  .m-title {
    img {
      width: 45px;
    }
  }

  .m-live-betting {
    .m-sub-navs {
      padding: 10px 0;
      border-radius: 16px 16px 0 0;
    }
  }
}
</style>

<style lang="scss" scoped>
[data-mode='light'] {
  .m-live-container {
    .market-navs {
      background: #fff;

      ::v-deep {
        .m-sub-navs {
          background: none;
        }

        .snap-nav-item {
          background: #f7f7f7;
          color: #333;

          &.active {
            background-image: linear-gradient(-66deg, #ffe74f 0%, #ffad31 100%);
            color: #000;
          }
        }
      }
    }
  }
}
</style>
